import { create } from "zustand";

// Whether the composer's editor failed to load, so the page takes no files that nothing could then send.
interface ComposerEditorStore {
    isEditorUnavailable: boolean;
    setEditorUnavailable: (isEditorUnavailable: boolean) => void;
}

export const useComposerEditorStore = create<ComposerEditorStore>()(set => ({
    isEditorUnavailable: false,
    setEditorUnavailable: isEditorUnavailable => set({ isEditorUnavailable })
}));
